import e from "./_baseIsMatch.js";
import m from "./_getMatchData.js";
import n from "./_matchesStrictComparable.js";
function h(a) {
  var t = m(a);
  return t.length == 1 && t[0][2] ? n(t[0][0], t[0][1]) : function(r) {
    return r === a || e(r, a, t);
  };
}
export {
  h as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseMatches.js
// module id = 1483
// module chunks = 67